<template lang="html">
  <section class="ArticleList">
    <div class="container">
      <h3 class="title sectionHeading is-padded">Siste nytt</h3>
      <transition-group name="fade" tag="div" class="columns is-multiline" id="ArticleContainer" itemscope itemtype="http://schema.org/ItemList">
        <news-item v-for="newsItem in newsItems"
          :title="newsItem.title"
          :image="newsItem.thumbnail"
          :lead="newsItem.lead"
          :slug="generateSlug(newsItem.slug.current)"
          :key="newsItem.title">
        </news-item>
      </transition-group>
      <div class="columns">
        <div class="column is-clearfix ArticleList-buttonContainer">
          <button type="button" name="button" class="button Button is-pink" v-bind:class="{ 'is-loading': isLoading}" v-on:click="loadMoreArticles">
            <span>Hent flere artikler</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import sanityQuery from '@/sanityQuery'
import FrontpageNewsItem from '@/components/FrontPageNewsItem'

var sliceStart = 0
var sliceStop = 3
var query = `*[_type == "article" && !(_id in path "drafts.**")]{title, lead, slug, "thumbnail": thumbnail{crop, hotspot, "asset": asset->{url, metadata}}, "publishDate": coalesce(publishedAt.local, _createdAt)} | order(publishDate desc) | [${sliceStart}...${sliceStop}]`

export default {
  name: 'NewsList',
  components: {
    'news-item': FrontpageNewsItem
  },
  data () {
    return {
      'newsItems': null,
      'isLoading': false
    }
  },
  created () {
    this.loadArticles()
  },
  methods: {
    loadArticles () {
      sanityQuery(query)
        .then((result) => {
          this.newsItems = result
        })
    },
    generateSlug (slug) {
      return `/${slug}`
    },
    loadMoreArticles () {
      sliceStop += 3
      this.isLoading = true
      sanityQuery(`*[_type == "article" && !(_id in path "drafts.**")]{title, lead, slug, "thumbnail": thumbnail{crop, hotspot, "asset": asset->{url, metadata}}, "publishDate": coalesce(publishedAt.local, _createdAt)} | order(publishDate desc) | [${sliceStart}...${sliceStop}]`)
        .then((result) => {
          this.newsItems = result
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="css">
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.is-padded {
  background-color: #fff;
  padding: 5px 5px 1px 5px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsList.vue